import { render, staticRenderFns } from "./UnidadMedidaView.vue?vue&type=template&id=53588d02&scoped=true"
import script from "./UnidadMedidaView.vue?vue&type=script&lang=js"
export * from "./UnidadMedidaView.vue?vue&type=script&lang=js"
import style0 from "./UnidadMedidaView.vue?vue&type=style&index=0&id=53588d02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53588d02",
  null
  
)

export default component.exports